import styled from 'styled-components'

export const TitlePage = styled.span`
  color: #00095f;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 43px;
  padding-bottom: 30px;
  font-family: FordAntennaRegular, Arial, Helvetica, sans-serif;
  margin-bottom: 31px;
`

export const SliderWrapper = styled.div`
  width: 100%;
  border-top: 1px solid #c8c8c8;
`

export const FullSlider = styled.div`
  max-width: 70vw;

  @media (max-width: 600px) {
    max-width: 80vw;
    margin-top: 35px;
  }
`

export const CardCharac = styled.div`
  // height: 300px;
  border-radius: 3px;
  background-color: #ffffff;
  margin-bottom: 20px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
  width: 291px;

  // @media (max-width: 768px) {
  //   width: 312px !important;
  // }

  @media (max-width: 768px) {
    width: 100% !important;
  }

  // @media (max-width: 375px) {
  //   width: 327px !important;
  // }

  // @media (min-width: 746px) and(max-width: 1024px) {
  //   width: 312px;
  // }

  // @media (min-width: 335px) and (max-width: 745px) {
  //   width: 327px;
  // }

  // @media only screen and (max-width: 280px) {
  //   width: 251px;
  // }

  img {
    width: 100%;
    border-radius: 3px;
  }
`

export const TitleSlider = styled.p`
  padding-top: 30px;
  padding-bottom: 30px;

  margin-left: 30px;
  color: #00095b;
  font-size: 18px !important;
  letter-spacing: 0;
  line-height: 24px;
  margin: 25px 0 0;
`

export const CardTitle = styled.div`
  margin-left: 23px;
  margin-right: 23px;
  padding-top: 20px;
  height: 72px;

  span {
    font-family: FordAntennaRegular, Arial, Helvetica, sans-serif;
    width: 258px;
    color: #00095b;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
  }
`

export const CardLink = styled.div`
  margin-left: 23px;
  padding-top: 12px;
  margin-bottom: 30px;
  width: fit-content;
  cursor: pointer;

  span {
    text-decoration: none !important;
  }

  a {
    color: #00095b !important;
    height: 24px;
    font-size: 18px;
    font-family: FordAntennaCondRegular;
    letter-spacing: 1px;
    line-height: 24px;
    margin-right: 15px;
  }

  &:hover {
    color: #1700f4;
    .text {
      color: #1700f4 !important;
      text-decoration: underline;
    }

    .fds-font--ford-icons__chevron-filled-left-path1-with-hover:before {
      color: #1700f4 !important;
      &:hover {
        color: #1700f4 !important;
      }
    }
    span {
      text-decoration: none !important;
    }
  }
`

export const Text = styled.div`
  // display: flex;
  // flex-direction: column;
  height: 150px;
  // justify-content: space-around;
`

export const CharImage = styled.div`
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  background: url(${({ url }) => url});
  background-position: center;
  background-size: cover;
  height: 157px;
`

export const Divider = styled.div`
  height: 1px;
  opacity: 0.2;
  transform: scaleX(-1);
  background-color: #000000;
  margin-right: 100px;
`
